// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculator-personalloans-v2-item/calculator-personalloans-v2-item.component.scss
// module id = 316
// module chunks = 0